import * as CONST from "./actionTypes";

export const templatesList = (payload, callBack) => {
  return {
    type: CONST.TEMPLATES_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const templatesList_Success = (payload) => ({
  type: CONST.TEMPLATES_LIST_SUCCESS,
  payload,
});

export const templatesList_Fail = (payload) => ({
  type: CONST.TEMPLATES_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EDIT TEMPLATES >>>>>>>>>>>>>>>*/
export const editTemplates = (payload, callBack) => {
  return {
    type: CONST.EDIT_TEMPLATES,
    payload: payload,
    callBack,
  };
};

export const editTemplates_Success = (payload) => ({
  type: CONST.EDIT_TEMPLATES_SUCCESS,
  payload,
});

export const editTemplates_Fail = (payload) => ({
  type: CONST.EDIT_TEMPLATES_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> UPDATE TEMPLATES >>>>>>>>>>>>>>>*/

export const updateTemplates = (payload, callBack) => {
  return {
    type: CONST.UPDATE_TEMPLATES,
    payload: { ...payload },
    callBack,
  };
};

export const updateTemplates_Success = (payload) => ({
  type: CONST.UPDATE_TEMPLATES_SUCCESS,
  payload,
});

export const updateTemplates_Fail = (payload) => ({
  type: CONST.UPDATE_TEMPLATES_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD TEMPLATES >>>>>>>>>>>>>>>*/

export const addTemplates = (payload, callBack) => {
  return {
    type: CONST.ADD_TEMPLATES,
    payload: { ...payload },
    callBack,
  };
};

export const addTemplates_Success = (payload) => ({
  type: CONST.ADD_TEMPLATES_SUCCESS,
  payload,
});

export const addTemplates_Fail = (payload) => ({
  type: CONST.ADD_TEMPLATES_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DELETE TEMPLATES >>>>>>>>>>>>>>>*/

export const deleteTemplates = (payload, callBack) => {
  return {
    type: CONST.DELETE_TEMPLATES,
    payload: payload,
    callBack,
  };
};

export const deleteTemplates_Success = (payload) => ({
  type: CONST.DELETE_TEMPLATES_SUCCESS,
  payload,
});

export const deleteTemplates_Fail = (payload) => ({
  type: CONST.DELETE_TEMPLATES_FAIL,
  payload,
});
